import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-addison-lee-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './addison-lee-banner.component.html',
  styleUrl: './addison-lee-banner.component.scss',
})
export class AddisonLeeBannerComponent {}
